import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/mikado/mikado/website/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["BlogListingContent"] */ "/home/runner/work/mikado/mikado/website/src/components/pages/resources/BlogListingContent.tsx");
